let sidebar = false;
let organizationName = '';

export const getSideBar = (): boolean => {
    return sidebar;
};

export const setSidebar = (value: boolean) => {
    sidebar = value;
};

export const getOrganizationName = (): string => {
    return organizationName;
};

export const setOrganizationName = (value: string) => {
    organizationName = value;
};
